import Phaser from 'phaser';
import { TEXT_RESOLUTION } from './platform';

// The HUD's one text style: monospace, crisp at device pixel ratio. Every
// kit component and the game's HUD go through this so nothing is rasterised
// at 1x on a high-DPI screen.
export const HUD_FONT = 'monospace';
export const INK = '#e6efe0';
export const INK_DIM = '#9fb09a';
export const BRASS = 0xb08d57;

export function hudText(scene: Phaser.Scene, x: number, y: number, s: string, size: number, color: string = INK): Phaser.GameObjects.Text {
  return scene.add.text(x, y, s, { fontFamily: HUD_FONT, fontSize: `${size}px`, color, resolution: TEXT_RESOLUTION });
}
